import React from "react";
import "./CategoryHeading.css";

function CategoryHeading({ Title }) {
  return (
    <div className="heading-category">
      <h1>{Title}</h1>
    </div>
  );
}

export default CategoryHeading;
